import { RouteObject } from 'react-router';
import { PATHS } from '../../routes/paths';
import { SupportPage } from './pages';

export const supportRoutes: RouteObject[] = [
  {
    path: PATHS.support,
    Component: SupportPage,
  },
];
